<template>
  <div>
    <label class="label">{{ $t('dimensions_select') }} <span class="warning-color">*</span></label>
    <div class="dimensions-input-block row">
      <InputText
        :disabled="value.length.disabled"
        class="col-xs-3"
        v-model="value.length.value"
        :rules="{required: required}"/>
      <InputText
        :disabled="value.width.disabled"
        class="col-xs-3"
        v-model="value.width.value"
        :rules="{required: required}"/>
      <InputText
        :disabled="value.height.disabled"
        class="col-xs-3"
        v-model="value.height.value"
        :rules="{required: required}"/>
      <div class="col-xs-3" v-if="!disabledMessure">
        <InputSelect
          :darkText="true"
          v-model="value.dimensionsType"
          :options="allowedDimensionTypes"
          :rules="{required: required}"/>
      </div>
      <InputText
        v-else
        class="col-xs-3"
        v-model="value.dimensionsType" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins.js';
import InputText from "@/components/elements/inputs/text.vue";
import InputSelect from "@/components/elements/inputs/select.vue";

export default {
  name: 'DimensionsSelect',
  mixins: [mixin],
  components: {
    InputText,
    InputSelect,
  },
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    disabledMessure: {
      type: Boolean,
      default: false,
    },
    allowed: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Object,
      default: () => {
        return{
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: '',
        }
      },
    }
  },
  computed: {
    allowedDimensionTypes() {
      const allTypes = this.unitsDimensionSelection;
      if (this.allowed && this.allowed.length > 0) {
        return allTypes.filter(item => this.allowed.includes(item.text));
      }
      return allTypes
    },
    ...mapGetters([
      "get_user",
    ]),
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('input', {
        width: this.value.width,
        height: this.value.height,
        length: this.value.length,
        dimensionsType: this.value.dimensionsType || this.get_user.dimension_type,
      });
    });
  },
}
</script>
